import styled from "styled-components";

export const ContainerConciliation = styled.div`
  .tableCustom {
    .ant-table-thead > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
    .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row) > td,
    .ant-table-thead > tr:hover:not(.ant-table-expanded-row) > td,
    .ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td {
      background-color: inherit !important;
      text-shadow: none;
    }
  }
  label {
    color: #9074bf;
    font-size: 14px;
    font-weight: bold;
    font: "Asap", sans-serif;
  }
  .green {
    color: rgb(51, 193, 98);
  }

  .red {
    color: rgb(212, 76, 76);
  }

  .gray {
    background: rgb(199, 199, 199) !important;

    &:hover {
      background: rgb(199, 199, 199) !important;
    }
  }
  .ant-table-row.gray:hover {
    background: rgb(199, 199, 199) !important;
  }

  .ant-table-row.gray:nth-child(even) {
    background: rgb(199, 199, 199) !important;
  }
`;
